/**
 *

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type BlankEnum = '';

export const BlankEnum = { '': '' } as const;
